module.exports = __webpack_public_path__ + "static/media/roadside-assistance.fd1f68a2.png";